import { ButtonColor } from '@ey-xd/ng-motif';

export class FileUploadResultModel {
  public constructor(
    public requestValidationSubmissionId: string,
    public errorMessage: string | null = null
  ) {}

  public get isValid(): boolean {
    return !this.errorMessage;
  }
}

export interface ValidationResponse {
  requestValidationSubmissionId: string;
  originalFileName: string;
  warningRecalculatedProductsCount: number;
  warningDuplicatedProductsCount: number;
  errorInvalidProductsCount: number;
  isValidForRequestCreation: boolean;
}

export interface ValidationRequestResponse {
  rowId: number;
  productId: string;
  description: string;
  countryCode: string;
  classificationType: string;
  priority: string;
  subDivision: string;
  dueDate: string;
  comment: string;
  validationError: string;
}

export interface CreateRequestResponse {
  requestEntityId: string;
  requestId: string;
  itemsCount: number;
  itemsCreatedCount: number;
  itemsExcludedCount: number;
  itemsTotalCount: number;
  itemsCreateErrors: string[];
  itemsAsyncProcessing: boolean;
}

export interface GetStatusResponse {
  requestEntityId: string;
  requestValidationSubmissionId: string;
  requestId: string;
  requestItemsTotal: number;
  requestFileItemsWithoutFileDuplicates: number;
  requestItemsCreated: number;
}

export interface ConfirmModalData {
  confirmAction: ValidateModalAction;
  title: string;
  message: string;
  confirmButton: {
    text: string;
    type: string;
    color: ButtonColor;
  };
  cancelButton?: {
    text: string;
    type: string;
    color: ButtonColor;
  };
}

export interface OnBehalfOfRequester {
  id: string;
  fullname: string;
  emailAddress: string;
}

export interface RequestCategory {
  requestCategoryId: string;
  name: string;
  description: string;
}

export type ValidateModalAction = 'submit' | 'discard' | 'timeout' | 'cancel' | 'success' | 'error' | 'resolve';
